import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, HostListener, Inject, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { UiHelper } from '@helpers/ui.helper';
// for material slide component etc.

import { Router } from '@angular/router';
import { NgImageSliderComponent } from 'ng-image-slider';
import { DOCUMENT } from '@angular/common';
import { pushToDataLayer } from '@helpers/gtm.util';

@Component({
  selector: 'slider',
  templateUrl: '../sharedTemplates/slider.component.html',
})
export class SliderComponent implements AfterViewInit, OnDestroy {
  @Input()
  isLive;

  defaultImg = 'angular/dist/assets/images/default.jpg';

  positionPX = 0;
  imageListArray = [];
  imageListArraySize = 0;
  selectedImage = 1;
  @ViewChild('nav', { read: ElementRef })
  slider: NgImageSliderComponent;
  imageObject: Array<object> = [];
  @Input()
  countRow = 1;

  @Input()
  slideShowTime = 2;

  @Input()
  set slideShow(e) {
    if (e) {
      this.slideShowSetter();
    }
  }

  windowsWidth;

  @Input()
  controller = true;
  @Input()
  heightMultiper = 1;
  @Input()
  background = 'transparent';
  @Input()
  marginInput = 0;
  @Input()
  objectFit = 'contain';

  @Input()
  set data(e) {
    try {
      this.imageListArray = [];

      if (e && e.length === 0) {
        return;
      }
      this.imageObject = [];

      const _imageListArray = [];
      const _imageObject = [];
      e.forEach(x => {
        const _data = {
          imageUrl: x.FileName,
          captions: x.Title ? x.Title : '',
          route: x.route,
          TourId: x.TourId,
          CatId: x.CatId,
          Link: x.Link,
        };
        const _data2 = {
          image: x.FileName,
          thumbImage: x.FileName,
          alt: '',
          title: '',
          Link: x.Link,
          index: x.index,
        };
        _imageListArray.push(_data);
        _imageObject.push(_data2);
      });

      this.imageListArray = _imageListArray;
      this.imageObject = _imageObject;

      this.imageListArraySize = this.imageListArray.length;
    } catch (e) {
      console.log(e);
      return;
    }
  }

  /* SUBSCRIBES */
  _slideShowInterval;
  _windowResized;

  constructor(
    private _UiHelper: UiHelper,
    public _Router: Router,
    private el: ElementRef,
    private _changeDetection: ChangeDetectorRef,
    @Inject(DOCUMENT) private document: Document
  ) {}

  onSwipeLeft(e) {
    //// console.log('left');
    if (this.selectedImage != this.imageListArraySize) {
      this.positionPX += -this.windowsWidth / this.countRow;
      this.selectedImage++;
    }
  }

  onSwipeRight(e) {
    //// console.log('right');

    if (this.selectedImage != 1) {
      this.positionPX += this.windowsWidth / this.countRow;
      this.selectedImage--;
    }
  }

  changeSlider(v) {
    this.positionPX = (-(v - 1) * this.windowsWidth) / this.countRow;
    this.selectedImage = v;
  }

  slideShowSetter() {
    this._slideShowInterval = setInterval(() => {
      if (this.selectedImage != this.imageListArraySize) {
        this.changeSlider(this.selectedImage + 1);
      } else {
        this.changeSlider(1);
      }
    }, this.slideShowTime * 1000);
  }

  onClickItem(e) {
    if (e.route != undefined) {
      this._Router.navigate([e.route], {
        queryParams: { CatId: e.CatId, TourId: e.TourId },
      });
      //// console.log('/' + e.route);
    } else {
      // this._Router.navigate([e.Link]);
      window.location.href = e.Link;
    }

    // this._Router.navigate(['/eventdetail', e]);
  }
  ngAfterViewInit(): void {
    if (!this.isLive) {
      if (this.windowsWidth === 0) {
        this.windowsWidth = this._UiHelper.windowsWidth;
      }

      this._windowResized = this._UiHelper.windowResized.subscribe(x => {
        this.windowsWidth = x.w;
        this.positionPX = (-(this.selectedImage - 1) * this.windowsWidth) / this.countRow;
      });
    } else {
      this.windowsWidth = this.el.nativeElement.offsetWidth;

      setTimeout(x => {
        this.windowsWidth = this.el.nativeElement.offsetWidth;
      }, 1000);
    }
  }

  goPage(router) {
    try {
      if (this.imageObject[router]['Link']) {
        this.document.location.href = this.imageObject[router]['Link'];

        pushToDataLayer({
          event: 'cta_click',
          link: this.imageObject[router]['Link'],
        });
      }
    } catch (e) {
      console.error('Slider route not found. Err.');
    }
  }

  ngOnDestroy(): void {
    clearInterval(this._slideShowInterval);
    if (!this.isLive) {
      this._windowResized.unsubscribe();
    }
  }
}
